import { Link } from "react-router-dom";
import { useT } from "../../i18n";
import { PRIVACY_URL, SHOWCASE_PAGES } from "../../constants/mintlabApps";
import useHomePager from "../../hooks/useHomePager";
import AppGrid from "./AppGrid";

// iPhone-style home screen: an iPhone/Android switch, one swipeable page of
// icons per platform, page dots, and a dock with Support / Privacy.
export default function HomeScreen() {
  const t = useT();
  const { ref, index, go } = useHomePager(SHOWCASE_PAGES);

  return (
    <div id="apps" className="ml-showcase">
      <div className="ml-segmented" role="tablist" data-index={index}>
        <span className="ml-segmented-thumb" aria-hidden="true" />
        {SHOWCASE_PAGES.map((p, i) => (
          <button
            key={p.key}
            type="button"
            role="tab"
            aria-selected={i === index}
            aria-controls={`ml-page-${p.key}`}
            className={i === index ? "active" : ""}
            onClick={() => go(i)}
          >
            {p.label}
          </button>
        ))}
      </div>

      <div className="ml-phone">
        <div className="ml-statusbar" aria-hidden="true">
          <span>9:41</span>
          <span className="ml-statusbar-icons">
            <svg viewBox="0 0 18 12" width="18" height="12" fill="currentColor">
              <rect x="0" y="8" width="3" height="4" rx="1" />
              <rect x="5" y="5.5" width="3" height="6.5" rx="1" />
              <rect x="10" y="3" width="3" height="9" rx="1" />
              <rect x="15" y="0" width="3" height="12" rx="1" />
            </svg>
            <svg viewBox="0 0 16 12" width="16" height="12" fill="currentColor">
              <path d="M8 2.2c2.3 0 4.4.9 6 2.4l1.2-1.3A10.4 10.4 0 0 0 8 .4 10.4 10.4 0 0 0 .8 3.3L2 4.6a8.6 8.6 0 0 1 6-2.4Zm0 3.6c1.3 0 2.5.5 3.5 1.3l1.2-1.3A7 7 0 0 0 8 4a7 7 0 0 0-4.7 1.8l1.2 1.3c1-.8 2.2-1.3 3.5-1.3Zm0 3.6c-.5 0-1 .2-1.3.5L8 11.6l1.3-1.7A2 2 0 0 0 8 9.4Z" />
            </svg>
            <span className="ml-battery">
              <span />
            </span>
          </span>
        </div>

        <div className="ml-pages" ref={ref}>
          {SHOWCASE_PAGES.map((p, i) => (
            <section
              key={p.key}
              id={`ml-page-${p.key}`}
              className="ml-page"
              role="tabpanel"
              aria-label={p.label}
            >
              <AppGrid apps={p.apps} />
            </section>
          ))}
        </div>

        <div className="ml-pagedots">
          {SHOWCASE_PAGES.map((p, i) => (
            <button
              key={p.key}
              type="button"
              className={i === index ? "on" : ""}
              aria-label={p.label}
              onClick={() => go(i)}
            />
          ))}
        </div>

        <nav className="ml-dock">
          <Link
            to="/support"
            className="ml-dock-item"
            aria-label={t("nav.support")}
          >
            <span className="ml-dock-icon ml-dock-support">
              <svg
                viewBox="0 0 24 24"
                width="30"
                height="30"
                fill="currentColor"
              >
                <path d="M12 3C6.9 3 3 6.5 3 11c0 2.4 1.1 4.5 2.9 6l-.7 3.1c-.1.5.4.9.9.6l3.4-1.8c.8.2 1.6.3 2.5.3 5.1 0 9-3.5 9-8.1S17.1 3 12 3Z" />
              </svg>
            </span>
            <span>{t("nav.support")}</span>
          </Link>
          <a
            href={PRIVACY_URL}
            className="ml-dock-item"
            aria-label={t("nav.privacy")}
          >
            <span className="ml-dock-icon ml-dock-privacy">
              <svg
                viewBox="0 0 24 24"
                width="28"
                height="28"
                fill="currentColor"
              >
                <path d="M12 2.5 4.5 5.3v6c0 4.6 3.2 8.8 7.5 10.2 4.3-1.4 7.5-5.6 7.5-10.2v-6L12 2.5Zm-1.2 13.3-3.3-3.3 1.4-1.4 1.9 1.9 4.3-4.3 1.4 1.4-5.7 5.7Z" />
              </svg>
            </span>
            <span>{t("nav.privacy")}</span>
          </a>
        </nav>
      </div>
    </div>
  );
}
